import { render, staticRenderFns } from "./ModalConfirm.vue?vue&type=template&id=997620ee&scoped=true"
import script from "./ModalConfirm.vue?vue&type=script&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirm.vue?vue&type=style&index=0&id=997620ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997620ee",
  null
  
)

export default component.exports